import { Divider } from "staysure-component-library";

import RichText from "@/components/atoms/rich-text/rich-text";

import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { formCmsData } from "../../../utils/contact-details-page.util";

function RetentionConsentSection() {
  const { cmsData } = useContactDetailsContext();
  const { retainQuoteConsent } = formCmsData(cmsData);

  return (
    <>
      <Divider />
      <div className="mt-spacing-l">
        {retainQuoteConsent && (
          <RichText
            richText={retainQuoteConsent}
            className="text-[14px] break-words font-body-font leading-[21px] text-text-body contact-rich-text"
          />
        )}
      </div>
    </>
  );
}
export default RetentionConsentSection;
